import { Controller } from "@hotwired/stimulus"
import GLightbox from "glightbox"
import "glightbox/dist/css/glightbox.min.css"

// Connects to data-controller="image-lightbox"
export default class extends Controller {
  connect() {
    this.initializeLightbox()
  }

  disconnect() {
    if (this.updateTimer) {
      clearTimeout(this.updateTimer)
    }
    if (this.lightbox) {
      this.lightbox.destroy()
    }
  }

  initializeLightbox() {
    // Find all image links in the content
    const imageLinks = this.element.querySelectorAll('a[href] img')

    // Add glightbox class to parent anchors
    imageLinks.forEach(img => {
      const link = img.parentElement
      if (link && link.tagName === 'A') {
        link.classList.add('glightbox')

        // Use the img src as the lightbox source (original full-size image)
        const imgSrc = img.getAttribute('src')
        const imgAlt = img.getAttribute('alt') || ''

        // Set data-glightbox with proper format
        if (imgSrc && !link.hasAttribute('data-glightbox')) {
          link.setAttribute('data-glightbox', `type: image; description: ${imgAlt}`)
          // Ensure href points to the image for lightbox
          link.setAttribute('href', imgSrc)
        }
      }
    })

    // Initialize GLightbox
    this.lightbox = GLightbox({
      touchNavigation: true,
      loop: false,
      autoplayVideos: false,
      closeButton: true,
      zoomable: true,
      draggable: true,
      openEffect: 'fade',
      closeEffect: 'fade'
    })
  }

  // Reinitialize when new content is added (for streaming)
  // Debounced to avoid excessive recreation during rapid updates
  contentUpdated() {
    if (this.updateTimer) {
      clearTimeout(this.updateTimer)
    }

    // Debounce lightbox updates to avoid expensive destroy/recreate cycles
    this.updateTimer = setTimeout(() => {
      if (this.lightbox) {
        this.lightbox.destroy()
      }
      this.initializeLightbox()
    }, 100)
  }
}
